
import { OK } from 'http-status-codes'
import getAxiosInstance from '../../../helpers/get_axios_instance'

export class TablaDetallePorCerealLinea3Service {
  static async getDataTablaDetallePorCerealLinea3 () {
    const axios = getAxiosInstance()
    const promise = axios.get('/consulta_neto_cereal_sector3')
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el reporte de tabla distribucion por cereal sector 3.')
      return (data)
    })
  }

  static async getDataTablaDetallePorCerealLinea3Total () {
    const axios = getAxiosInstance()
    const promise = axios.get('/consulta_neto_cereal_sector3_total')
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el reporte de tabla distribucion por cereal sector 3.')
      return (data)
    })
  }
}
